import {
  CRUISE_GTAG_CONVERSION,
  CRUISE_GTAG_ID,
  CRUISE_GTAG_PHONE,
  CRUISE_GTAG_SCRIPT_ID,
} from '../constants/cruiseGtag';

let gtagActive = false;

function ensureGtagFn() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function defineConversionHelper() {
  window.gtag_report_cruise_conversion = function gtag_report_cruise_conversion(url) {
    const callback = function callback() {
      if (typeof url !== 'undefined' && url) {
        window.location.href = url;
      }
    };
    window.gtag('event', 'conversion', {
      send_to: CRUISE_GTAG_CONVERSION,
      value: 1.0,
      currency: 'USD',
      event_callback: callback,
    });
    return false;
  };
}

function loadCruiseGtag() {
  if (gtagActive || typeof window === 'undefined') return;

  ensureGtagFn();

  if (!document.getElementById(CRUISE_GTAG_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = CRUISE_GTAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${CRUISE_GTAG_ID}`;
    document.head.insertBefore(script, document.head.firstChild);
  }

  window.gtag('js', new Date());
  window.gtag('config', CRUISE_GTAG_ID);
  window.gtag('config', CRUISE_GTAG_CONVERSION, {
    phone_conversion_number: CRUISE_GTAG_PHONE,
  });

  defineConversionHelper();
  gtagActive = true;
}

function attachCruiseCallConversionTracking() {
  function handleClick(event) {
    const link = event.target.closest('a[href^="tel:"]');
    if (!link) return;

    const url = link.getAttribute('href');
    if (!url) return;

    if (typeof window.gtag_report_cruise_conversion === 'function') {
      event.preventDefault();
      window.gtag_report_cruise_conversion(url);
    }
  }

  document.addEventListener('click', handleClick, true);
  return () => document.removeEventListener('click', handleClick, true);
}

/** Load Google tag on cruise pages only */
export function initCruiseGtag() {
  loadCruiseGtag();
  return attachCruiseCallConversionTracking();
}

/** Remove tag when user leaves /cruises */
export function destroyCruiseGtag() {
  const script = document.getElementById(CRUISE_GTAG_SCRIPT_ID);
  if (script) script.remove();

  if (typeof window !== 'undefined') {
    delete window.gtag_report_cruise_conversion;
  }

  gtagActive = false;
}
